module.exports = __webpack_public_path__ + "img/download-icon.7727bb80.svg";